import React, { useEffect, useState } from "react";

const PartnerUser = () => {
    const [user, setUser] = useState(null);
    const [userError, setUserError] = useState(null);

    const [invoice, setInvoice] = useState(null);
    const [invoiceError, setInvoiceError] = useState(null);
    const [loadingInvoice, setLoadingInvoice] = useState(false);

    const [countries, setCountries] = useState([]);
    const [countriesError, setCountriesError] = useState(null);
    const [loadingCountries, setLoadingCountries] = useState(false);

    const [currency, setCurrency] = useState([]);
    const [currencyError, setCurrencyError] = useState(null);
    const [loadingCurrency, setLoadingCurrency] = useState(false);
    const getToken = async () => {
        const response = await fetch("https://onza-api.333.kg/api/auth/token", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                partner_id: "partner_001",
                secret: "qwe123ewq",
            }),
        });

        if (!response.ok) {
            throw new Error(`Ошибка токена: ${response.status}`);
        }

        const data = await response.json();
        return data.token;
    };

    const tokenRef = React.useRef(null);

    useEffect(() => {
        const initAuth = async () => {
            try {
                tokenRef.current = await getToken();
            } catch (e) {
                console.error("Ошибка авторизации", e);
            }
        };

        initAuth();
    }, []);

    const signedRequest = async (url, body = {}) => {
        if (!tokenRef.current) {
            throw new Error("Токен не получен");
        }

        const partnerId = "partner_001";
        const secret = "qwe123ewq";
        const timestamp = Math.floor(Date.now() / 1000).toString();

        // ✅ Подпись как на сервере
        const payload = partnerId + timestamp + (body && Object.keys(body).length ? JSON.stringify(body) : "");
        const signature = await generateHMAC(payload, secret);

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenRef.current}`,
                "X-Partner-Id": partnerId,
                "X-Timestamp": timestamp,
                "X-Signature": signature,
            },
            body: JSON.stringify(body),
        });

        if (!response.ok) {
            throw new Error(`Ошибка запроса: ${response.status}`);
        }

        return response.json();
    };



    // -------------------- страны --------------------

    const fetchCountries = async () => {
        try {
            setLoadingCountries(true);
            const data = await signedRequest(
                "https://onza-api.333.kg/api/directory/country",
                {}
            );
            setCountries(data);
        } catch (e) {
            setCountriesError(e.message);
        } finally {
            setLoadingCountries(false);
        }
    };

    const fetchPickupPoint = async () => {
        try {
            setLoadingCountries(true);
            const data = await signedRequest(
                "https://onza-api.333.kg/api/directory/pickup-point",
                {}
            );
        } catch (e) {
            setCountriesError(e.message);
        } finally {
            setLoadingCountries(false);
        }
    };


    const fetchCurrency = async () => {
        try {
            setLoadingCurrency(true);
            const data = await signedRequest(
                "https://onza-api.333.kg/api/directory/currency",
                {}
            );
            setCurrency(data);
        } catch (e) {
            setCurrencyError(e.message);
        } finally {
            setLoadingCurrency(false);
        }
    };



    useEffect(() => {
        if (!tokenRef.current) return
        const fetchUser = async () => {
            try {
                const body = {
                    phone: "0555123456",
                    inn: "1234567890",
                    first_name: "Иван",
                    last_name: "Иванов",
                    sex: 1,
                };

                const data = await signedRequest(
                    "https://onza-api.333.kg/api/partner/user",
                    body
                );
                console.log(data);
                setUser(data);
            } catch (e) {
                setUserError(e.message);
            }
        };

        fetchUser();
    }, [tokenRef.current]);



    // -------------------- /partner/invoice --------------------
    const createInvoice = async () => {
        try {
            setLoadingInvoice(true);
            console.log(user);
            const body = {
                user_guid: user.guid,
                country_guid: '689D4123-3483-4BB5-8E8F-7517D7EB4607',
                tracking_number: "INV2026021132029B",

            };

            const data = await signedRequest(
                "https://onza-api.333.kg/api/partner/invoice/cancel",
                body
            );
            // fetchCountries()
            // fetchCurrency()
            // fetchPickupPoint()
            setInvoice(data);
        } catch (e) {
            setInvoiceError(e.message);
        } finally {
            setLoadingInvoice(false);
        }
    };


    // -------------------- render --------------------
    return (
        <div>
            <h2>Пользователь</h2>
            {userError && <div>Ошибка: {userError}</div>}
            {!user && !userError && <div>Загрузка...</div>}
            {user && (
                <div>
                    <p>Код: {user.codeid}</p>
                    <p>Имя: {user.first_name} {user.last_name}</p>
                    <p>Телефон: {user.phone}</p>
                    <p>Пол: {user.sex}</p>
                </div>
            )}

            <hr />

            <h2>Страны</h2>
            {loadingCountries && <div>Загрузка стран...</div>}
            {countriesError && <div>Ошибка: {countriesError}</div>}

            {countries.length > 0 && (
                <ul>
                    {countries.map(c => (
                        <li key={c.guid}>
                            {c.country} — {c.city}
                        </li>
                    ))}
                </ul>
            )}

            <hr />

            {currency.length > 0 && (
                <ul>
                    {currency.map(c => (
                        <li key={c.guid}>
                            {c.codeid} — {c.name}
                        </li>
                    ))}
                </ul>
            )}

            <hr />

            <h2>Создать инвойс</h2>
            {invoiceError && <div>Ошибка: {invoiceError}</div>}
            <button onClick={createInvoice} disabled={loadingInvoice}>
                {loadingInvoice ? "Создание..." : "Создать инвойс"}
            </button>

            {invoice && (
                <div>
                    <h3>Инвойс создан</h3>
                    <pre>{JSON.stringify(invoice, null, 2)}</pre>
                </div>
            )}
        </div>
    );
};

export default PartnerUser;

// -------------------- Web Crypto API для HMAC SHA256 --------------------
async function generateHMAC(payload, secret) {
    const encoder = new TextEncoder();
    const key = await crypto.subtle.importKey(
        "raw",
        encoder.encode(secret),
        { name: "HMAC", hash: "SHA-256" },
        false,
        ["sign"]
    );

    const sigBuffer = await crypto.subtle.sign("HMAC", key, encoder.encode(payload));
    return Array.from(new Uint8Array(sigBuffer))
        .map(b => b.toString(16).padStart(2, "0"))
        .join("");
}
